import { throttle } from "../utils/throttle";

const THROTTLE_LIMIT = 250;

class ImageSizes {
  /**
   * @param {HTMLImageElement} image
   */
  constructor(image) {
    this.image = image;
    this.connect();
  }

  connect = () => {
    this.setSizes();

    this.image.addEventListener("load", this.setSizes, { once: true });

    this.throttledSetSizes = throttle(this.setSizes, THROTTLE_LIMIT);
    window.addEventListener("resize", this.throttledSetSizes);
  };

  setSizes = () => {
    this.image.setAttribute("sizes", this.image.width);
  };

  disconnect = () => {
    this.image.removeEventListener("load", this.setSizes);
    window.removeEventListener("resize", this.throttledSetSizes);
  };
}

export default ImageSizes;
